import { View, StyleSheet, TextInputProps, ViewStyle } from "react-native";
import { BottomSheet } from "@rneui/themed";
import Text from "src/common/components/text";
import useUserData from "libs/hooks/useUserData";
import { useState, useMemo } from "react";
import AddressItem from "./AddressItem";
import userUser from "libs/hooks/useUser";
import Button from "./button";
import variables from "src/common/assets/variables";
import { useNavigation } from "@react-navigation/native";
import translate from "libs/locale";
import { MaterialIcons } from "@expo/vector-icons";
import { SCREEN_WIDTH, TABLET_PC } from "../libs/utils/constants";
import { getButtonModalWidth } from "../libs/utils/dimensions";
import AnimatedBottomSheet from "./animatedBottomSheet";

type SearchBarProps = {
  containerStyle?: object;
} & TextInputProps;

type Props = {
  containerStyle?: ViewStyle;
  onAddressChange: (id: string) => void;
  selectedAddressId: string;
} & SearchBarProps &
  TextInputProps;

const AddressSelection = ({
  containerStyle,
  onAddressChange,
  selectedAddressId,
}: Props) => {
  const [openPickAddress, setOpenPickAddress] = useState(false);
  const navigation = useNavigation<any>();
  const userData = userUser();

  const addresses = userData?.address;

  const pickAddress = () => {
    setOpenPickAddress((val) => !val);
  };

  const setAddress = (id: string) => {
    onAddressChange(id);
    pickAddress();
  };

  const addAddress = () => {
    navigation.navigate("EditAddress" as never, {
      data: null,
      addresses: addresses || [],
      id: null,
    });
  };

  const tempAddressData = addresses.find(
    (it) => it.location?._id === selectedAddressId
  );

  let addressData = tempAddressData;
  if (!addressData) {
    addressData = addresses[0];
  }

  return (
    <View style={[styles.container, containerStyle]}>
      <>
        <View style={styles.header}>
          <Text style={styles.headerName}>{translate("address")}</Text>
          {addressData && (
            <Button
              solid={false}
              onPress={pickAddress}
              style={styles.pickAddress}
            >
              <Text
                style={[styles.headerName, { color: variables.$brandColor }]}
              >
                {translate("pick")}
              </Text>
              <MaterialIcons
                name="arrow-back-ios"
                size={24}
                color={variables.$brandColor}
                style={styles.nextArrow}
              />
            </Button>
          )}
        </View>
        {!addressData && (
          <Button solid={false} onPress={addAddress} style={styles.addAddress}>
            <Text style={styles.headerName}>
              {translate("clickToAddAddress")}
            </Text>
          </Button>
        )}
      </>
      {addressData && (
        <>
          <AddressItem
            data={addressData}
            containerStyle={styles.addressItem}
            style={styles.addressItemStyle}
          />
          <AnimatedBottomSheet
            isVisible={openPickAddress}
            onBackdropPress={() => setOpenPickAddress(false)}
          >
            <View
              style={[
                styles.addressListContainer,
                TABLET_PC && styles.tabletContainer,
              ]}
            >
              <View style={[styles.header, styles.bottomSheetHeader]}>
                <Text style={styles.headerName}>
                  {translate("pleasePickAddress")}
                </Text>
                <Button
                  solid={false}
                  onPress={pickAddress}
                  style={styles.close}
                >
                  <Text style={[styles.headerName, { fontSize: 18 }]}>✕</Text>
                </Button>
              </View>
              {addresses.map((item, i) => (
                <AddressItem
                  key={i.toString()}
                  data={item}
                  containerStyle={styles.addressItem}
                  style={[
                    styles.addressItemStyle,
                    ((tempAddressData &&
                      item.location?._id === selectedAddressId) ||
                      (!tempAddressData && i === 0)) &&
                      styles.selectedAddress,
                  ]}
                  onPress={setAddress}
                  textStyle={
                    ((tempAddressData &&
                      item.location?._id === selectedAddressId) ||
                      (!tempAddressData && i === 0)) &&
                    styles.selectedAddressText
                  }
                />
              ))}
            </View>
          </AnimatedBottomSheet>
        </>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  nextArrow: {
    transform: [{ rotateY: "180deg" }],
  },
  pickAddress: {
    flexDirection: "row",
    alignItems: "center",
  },
  container: {
    backgroundColor: "#fff",
  },
  addAddress: {
    height: 50,
  },
  close: {},
  addressListContainer: {
    backgroundColor: "#fff",
    padding: 20,
  },
  tabletContainer: {
    alignSelf: "center",
    width: getButtonModalWidth(0.5),
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
  },
  header: {
    borderBottomColor: "#F4F4F4",
    borderBottomWidth: 1,
    marginTop: 0,
    flexDirection: "row",
    justifyContent: "space-between",
    paddingBottom: 12,
  },
  bottomSheetHeader: {
    borderBottomWidth: 0,
    paddingBottom: 0,
  },
  headerName: {
    color: "#636E72",
    fontSize: 14,
    fontFamily: "MontserratBold",
  },
  addressItem: {
    marginHorizontal: 0,
    marginTop: 10,
  },
  addressItemStyle: {
    shadowOffset: {
      width: 0,
      height: 0,
    },
    elevation: 0,
    borderWidth: 1,
    borderColor: "#636E7210",
    shadowRadius: 0,
  },
  selectedAddress: {
    backgroundColor: variables.$buttonColor,
  },
  selectedAddressText: {
    color: "#fff",
  },
});

export default AddressSelection;
